/* eslint-disable default-param-last */
import { get } from '../helpers/FetchHelper'

const baseUrl = `${process.env.REACT_APP_API_FIREBASE}dashboard/`

export const getDashData = async (
  type = 'homedash',
  startDate,
  endDate,
  partnerId = 'null',
  unitId = 'null'
) => {
  try {
    const url = `${baseUrl}reports/${type}/${startDate}/${endDate}/${partnerId}/${unitId}`
    return await get(url)
  } catch (e) {
    console.log(e)
    return []
  }
}
